import { getGtmData } from '..';

const switchOrSTP = () => ({
  onSwitchPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/my-holdings/switch/home',
    //   title: 'PFM - Online Investments - Portfolio - My Holdings - Switch - Home',
    //   cd24: getGtmData('cd24'),
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Switch - Landing Screen',
    // });
  },
  onClickContinue: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Switch - Home - Continue',
    //   cd68: getGtmData('cd68')?.toLowerCase(),
    // });
  },
  onSTPComponentPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/my-holdings/switch/transfer-type',
    //   title: 'PFM - Online Investments - Portfolio - My Holdings - Switch - Transfer Type',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Switch - Transfer Type',
    // });
  },
  onClickProceed: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Switch - Transfer Type - Proceed',
    //   cd69: getGtmData('cd69')?.toLowerCase(), // Pass either one time or systematic transfer
    //   cd70: getGtmData('cd70')?.toLowerCase(), // Pass either amount or units as selected by the user
    //   cd75: getGtmData('cd75')?.toLowerCase(), //  Pass either full switch or partial switch
    // });
  },
  onOtpComponentLoad: (formSchemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/my-holdings/switch/scheme-' + formSchemeName + '/verify-otp',
    //   title:
    //     'PFM - Online Investments - Portfolio - My Holdings - Switch - Scheme - ' + formSchemeName + ' - Verify OTP',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Switch - ' + formSchemeName + ' - Verify OTP',
    // });
  },
  onClickOfCloseOTP: (formSchemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Switch - ' + formSchemeName + ' - Close',
    // });
  },
  onClickOfSubmitOTP: (formSchemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Switch - ' + formSchemeName + ' - Submit',
    // });
  },
  onSwitchSuccessPageLoad: (formSchemeName: string, toSchemeName: string, referenceNumber: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page:
    //     'vpv/pfm/online-investments/portfolio/my-holdings/switch/from-' +
    //     formSchemeName +
    //     '-to-' +
    //     toSchemeName +
    //     '/switch-request-submitted',
    //   title:
    //     'PFM - Online Investments - Portfolio - My Holdings - Switch - From - ' +
    //     formSchemeName +
    //     ' - To - ' +
    //     toSchemeName +
    //     ' - Switch Request Submitted',
    //   cd71: referenceNumber, // Pass the reference number
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label:
    //     'Portfolio - My Holdings - Switch - From: ' +
    //     formSchemeName +
    //     ' - To: ' +
    //     toSchemeName +
    //     ' - Switch Request Submitted',
    // });
  },
  onClickOfBackToHoldingFromSwitchSuccessPage: (formSchemeName: string, toSchemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label:
    //     'Portfolio - My Holdings - Switch - From: ' +
    //     formSchemeName +
    //     ' - To: ' +
    //     toSchemeName +
    //     ' - Switch Request Submitted - Back to My Holdings',
    // });
  },
  onClickNudgeInSuccessPage: (actionName: string, formSchemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - ' + formSchemeName + ' - Investment Successful - ' + actionName, // Pass the Action 1 button text in <<action_1>>. For example, if Action 1 button text is "Every Goal Deserves a SIP. Start one more SIP", pass it in <<action_1>>
    // });
  },
});

export default switchOrSTP;
